function roundedPrice(price: number) {
  return (Math.round(100 * price) / 100)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

// separate thousands by comma
export function formatPrice(price: number) {
  return '$' + roundedPrice(price);
}

